import React from 'react';
import PropTypes from 'prop-types';
import HeaderScene from '../../Site/HeaderScene';
import {
  HeaderWrapperStyled,
  WavesContainerStyled,
  WavesHeaderSceneStyled,
} from './styles/ErrorNoDataStyled';
import LogoWom from '../../../../images/logowom.svg';

const Layout = ({ children }) => {
  return (
    <>
      <HeaderWrapperStyled>
        <img src={LogoWom} alt="logo WOM" />
      </HeaderWrapperStyled>
      <WavesContainerStyled>
        <WavesHeaderSceneStyled>
          <HeaderScene />
        </WavesHeaderSceneStyled>
      </WavesContainerStyled>
      {children}
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
